import { GitPullRequestIcon } from '@phosphor-icons/react';

import type { PullRequest } from '@/api-models/sandbox-git';

/** Short-lived link to a PR opened from this tab, shown in the header once one exists. */
export function PullRequestLink({ pull }: { pull: PullRequest }) {
  return (
    <a
      href={pull.html_url}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-1 text-2xs text-brand-text outline-none hover:underline hover:text-brand focus-visible:ring-2 focus-visible:ring-brand rounded"
    >
      <GitPullRequestIcon size={12} />#{pull.number}
    </a>
  );
}
